import { gql } from "apollo-boost";

export const ChannelTeamFragment = gql`
    fragment ChannelTeamFragment on ChannelTeam {
        id
        createdAt
        name
        teamID
        channel
        members {
            id
            firstName
            lastName
        }
    }
`;
